import { render, staticRenderFns } from "./depositRequestModal.vue?vue&type=template&id=6640d06b&scoped=true"
import script from "./depositRequestModal.vue?vue&type=script&lang=js"
export * from "./depositRequestModal.vue?vue&type=script&lang=js"
import style0 from "./depositRequestModal.vue?vue&type=style&index=0&id=6640d06b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6640d06b",
  null
  
)

export default component.exports